module.exports = __webpack_public_path__ + "static/img/sec1-cont01@m.d03ee27.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lgwatersolution/sec1-cont01@m.png
// module id = k5qk
// module chunks = 0